// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator employee_onboarding`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import companies from 'modules/core/store/collections/companies'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'
import users from 'modules/core/store/collections/users'

import contractVersionsPayrollPolicies from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import employees from 'modules/employees/store/collections/employees'
import payrollPolicies from 'modules/payroll_bundle/store/collections/policies'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 4 cases in this module */,
    [contractVersionsPayrollPolicies, {}] /* Referenced by 14 cases in this module */,
    [employeeGroups, {}] /* Referenced by 3 cases in this module */,
    [employees, {}] /* Referenced by 23 cases in this module */,
    [features, {}] /* Referenced by 7 cases in this module */,
    [legalEntities, {}] /* Referenced by 20 cases in this module */,
    [memberships, {}] /* Referenced by 1 cases in this module */,
    [payrollPolicies, {}] /* Referenced by 16 cases in this module */,
    [teams, {}] /* Referenced by 1 cases in this module */,
    [users, {}] /* Referenced by 18 cases in this module */,
  ] /* Generated file 👉 artifacts/employee_onboarding-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
